import { VendorArchivPage } from "../vendor-archiv.page";
import { useCentralStore } from "../../../store/Central";

export const VendorArchivPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	return <VendorArchivPage organizationId={organizationId} />;
};
